<h2 mat-dialog-title>Unsaved Changes</h2>
<mat-dialog-content>
  <p>You have unsaved changes. If you leave now, your changes will be discarded.</p>
  <p>Do you want to save your changes?</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="ui-unsaved-dialog__actions">
  <button mat-button type="button" (click)="choose('cancel')">Cancel</button>
  <button mat-stroked-button color="warn" type="button" (click)="choose('discard')">Don't Save</button>
  <button mat-flat-button color="primary" type="button" (click)="choose('save')">Save</button>
</mat-dialog-actions>
